import { render, staticRenderFns } from "./MedicalRecordImageUploader.vue?vue&type=template&id=69a57332&scoped=true&"
import script from "./MedicalRecordImageUploader.vue?vue&type=script&lang=js&"
export * from "./MedicalRecordImageUploader.vue?vue&type=script&lang=js&"
import style0 from "./MedicalRecordImageUploader.vue?vue&type=style&index=0&id=69a57332&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a57332",
  null
  
)

export default component.exports